@let desktop = (isDesktop | async);
@let mobile = (isMobile | async);

<ng-container *transloco="let t; prefix: 'baseLayout'">
    <mat-sidenav-container class="base-layout-container">
        <!-- SIDENAV -->
        <mat-sidenav #sidenav class="sidenav" [mode]="desktop ? 'side' : 'over'" [opened]="desktop">
            <div class="sidenav-content">
                <div class="x-container">
                    <button type="button" aria-label="Chiudi sidenav" (click)="onToggleSidenav()"
                        class="sidenav-close-btn">
                        <i class="fa-regular fa-xmark"></i>
                    </button>
                </div>

                <img src="../../../assets/logo-sidenav.svg" alt="Q8 Oils" class="logo"/>

                <mat-nav-list class="nav-list-main">
                    <div class="nav-list-block">
                        @for (menu of menuList; track menu.id) {
                        <!-- TODO: Quello corretto è la lettura di ".providerName"
                                *ngComponentOutlet="getSidenavProviderComponent(menu.providerName); -->
                        <ng-container *ngComponentOutlet="getSidenavProviderComponent(menu.label); 
                                inputs: { 
                                    menuItem: menu, 
                                    onClickEvent: handleClose
                                }">
                        </ng-container>
                        }

                        <!-- Pulsante incassi hardcodato -->
                        <!-- <ui-sidenav-item
                            [menuItem]="revenuesSidenavItem"
                            [onClickEvent]="handleClose">
                        </ui-sidenav-item> -->
                        
                        <!-- Pulsante profilo hardcodato -->
                        <ui-sidenav-item
                            [menuItem]="profileSidenavItem"
                            [onClickEvent]="handleClose">
                        </ui-sidenav-item>
                    </div>
                </mat-nav-list>
            </div>

            <!-- appVersion lo trovi dentro app.constants.ts -->
            <span class="sidenav-version label-small"
                [matTooltip]="baseUrl"
                matTooltipPosition="above">{{ appVersion }}</span>
        </mat-sidenav>

        <mat-sidenav-content #content>
            <!-- HEADER -->
            <mat-toolbar class="toolbar">
                <div class="toolbar-left">
                    <button mat-icon-button type="button" aria-label="Menu" (click)="onToggleSidenav()">
                        <i class="fa-regular fa-bars"></i>
                    </button>

                    @if(desktop && headerTitle()) {
                        <span class="toolbar-section-title headline-medium">{{ headerTitle() }}</span>
                    }
                </div>

                @if (!desktop && headerTitle()) {
                    <span class="toolbar-section-title toolbar-section-title-mobile headline-medium">
                        {{ headerTitle() }}
                    </span>
                }

                <div class="toolbar-right">
                    @if(!mobile || !isSearchOpen){
                        <!-- <button mat-icon-button type="button" aria-label="Messages">
                            <i class="fa-regular fa-envelope"></i>
                        </button>

                        <mes-box-messages></mes-box-messages> -->
                        @for (item of headerActions(); track $index) {
                            <button mat-icon-button type="button" [aria-label]="item.label" (click)="item.action()">
                                <i [attr.class]="getRegularIconClasses(item.icon)"></i>
                            </button>
                        }

                    }
                </div>
            </mat-toolbar>

            <div class="page-layout-grid"
                [class.grid-closed]="!(advisorBarLayoutService.hasAdvisorContent | async) || !(isAdvisorOpen | async)">
                <!-- BODY -->
                <main class="main-content">
                    <div class="page-content-shell">
                        <section class="page-grid">
                            <router-outlet></router-outlet>
                        </section>
                    </div>
                </main>

                <!-- Se l'advisor bar è valorizzata allora la gestisco -->
                @if (advisorBarLayoutService.hasAdvisorContent | async) {
                <!-- ADVISOR BAR -->
                <aside class="advisor-bar"
                    [class.bar-hidden]="!(isAdvisorOpen | async)"
                    [ngClass]="advisorBarLayoutService.advisorClass | async">
                    <button class="toggle-advisor" (click)="toggleAdvisorBar()">
                        <i [attr.class]="(isAdvisorOpen | async) ? 'fa-regular fa-chevron-right' : 'fa-regular fa-chevron-left'"></i>
                    </button>

                    <div class="advisor-content">
                        <!-- contenuto dinamico -->
                        <ng-template [cdkPortalOutlet]="advisorBarLayoutService.advisorPortal | async"></ng-template>
                    </div>
                </aside>
                }
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>
</ng-container>
